// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import { onMounted } from 'vue'
import { PCSPageNames, setPageName } from '@/store/pageName'

// import hybridPage from '@/lib/hybridPage'
import SearchInput from '@/pages/shop/components/_SearchInput.vue'
import i18n from '@/lang/i18n.ts'

// hybridPage()

createApp({
	name: 'PCSHomePage',
	components: {
		SearchInput,
	},
	setup() {
		onMounted(() => {
			setPageName(PCSPageNames.Home)
		})

		return {}
	},
})
	.use(i18n)
	.mount('#bsMain')
